// import React, { Component } from 'react';

import { useState } from "react";
import * as React from "react";
import axios from "axios";
import Carousel from "react-material-ui-carousel";
import Button from "@mui/material/Button";
import "./placesNearMe.css";


function App() {
  const [zipcode, setZipcode] = useState("");
  const [places, setPlaces] = useState([""]);

  const cabbyAnimation = require("./placesNearMe-Images/taxi-animation.gif");  
  const barIcon = require("./placesNearMe-Images/bar.png");

  function Example(content) {
    return (
      <Carousel
        NavButton={({ onClick, className, style, next, prev }) => {
          return (
            <Button onClick={onClick}  className="next-prev-button" style={{
              marginTop: "250%",
              color: "white",
              fontFamily: "Eczar-Medium",
              fontWeight: "200",
              backgroundColor: "#66222e",
              borderRadius: "20px",
              opacity: "1",
            }}>
              {next && "Next"}
              {prev && "Prev"}
              {/* style={{backgroundColor: "rgb(255,0,255)"}} */}
            </Button>
          );
        }}
        NextIcon="Next" // Change the "inside" of the next button to "next"
        PrevIcon="Prev" // Change the "inside of the prev button to "prev"
      >
        {content.map((item) => (
          <Item place={item} />
        ))}
      </Carousel>
    );
  }

  function Item(props) {
    return (
      <div className="PNM-Carousel" align="center">
        <img className="imageStyle-PNM" alt="Icon" src={barIcon} />
        <br></br>
        <br></br>
        <h2>{props["place"].name}</h2>
        <p> Address: {props["place"].address} </p>
        <p> Rating: {props["place"].rating}</p>
        

        <br />
      </div>
    );
  }

  
  let handleSubmit = async (e) => {
    e.preventDefault();
    const corsProxy = 'https://cors-anywhere.herokuapp.com/';
    const googlePlacesURL = `${corsProxy}https://maps.googleapis.com/maps/api/place/textsearch/json?query=bars+in+${zipcode}&key=AIzaSyDdmBlHQ3-umVvJjjtLzevebIn9NtU0wAg`;
  
    try {
      let response = await axios.get(googlePlacesURL);
      let data = response.data.results.splice(0, 5);
 
      let placesArray = data.map(place => ({
        name: place.name,
        address: place.formatted_address, // Adjust according to the actual API response structure
        rating: place.rating // Adjust according to the actual API response structure
      }));
      setPlaces(placesArray); // This will update the state and trigger a re-render
    } catch (err) {
      console.error(err);
    }
  };
  
  
  return (
    <>
      <div className="placesNearMeStyle" align="center">
        <br></br>
        <div className="PNM-HEADING-TITLE">
          <h1 className="Places-Near-Me-Heading-Title"> Places Near Me </h1>
        </div>
        <br></br>
        <div className="cabbyAnimation-Div" align="center">
          <img src={cabbyAnimation} style={{borderRadius: "20px"}}  alt="Taxi Animation"></img>
        </div>
        <br />
        <br></br>
        <h4 className="PNM-Zipcode">Enter Your Zipcode Below To Find Bars Near You!</h4>
          <br />
        <form style={{width: "40%" }} onSubmit={handleSubmit}>
          <input type="text" className="zipcode-NPM" value={zipcode} placeholder="Zipcode" onChange={(e) => setZipcode(e.target.value)}/>
          <hr />
          <div className="Explore-PNM" align="center">
          {/* <Button className="button-style-NPM" variant="contained" size="lg" type="submit">
            Search
          </Button> */}

          <button className="NPM-ZipCode-Button-Style" type="submit">Search</button>
          </div>
          <br></br>
          {places.length > 1 && (
            
            <div className="PNM-Div" align="center">
              <br></br>
              <div className="PNM-Carousel" align="center">{Example(places ?? [])}</div>
            </div>
          )}
        </form>
      </div>
    </>
  );
}

export default App;
